/** Which layer of the props stack a merged value came from, in merge order. */
export enum SourceType {
  ROOT = 'ROOT',
  COLUMN = 'COLUMN',
  DEFAULTS = 'DEFAULTS',
  OVERRIDES = 'OVERRIDES',
  LOCAL_STYLE = 'LOCAL_STYLE',
  LOCAL_STYLE_TABLET = 'LOCAL_STYLE_TABLET',
  LOCAL_STYLE_MOBILE = 'LOCAL_STYLE_MOBILE',
  ELEMENT_PROPS = 'ELEMENT_PROPS',
  ELEMENT_TABLET = 'ELEMENT_TABLET',
  ELEMENT_MOBILE = 'ELEMENT_MOBILE',
  GLOBAL_STYLE = 'GLOBAL_STYLE',
}

/** One layer's contribution to a merge. */
export interface PropsSource {
  value: unknown;
  source: SourceType | null;
}

export type MergeResult = Record<any, any>;
